module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.0a203fd6.woff2";